import { Layers, Sparkles, Palette, Package2, Truck } from "lucide-react";

const LENS_TYPES = ["Single Vision", "Bifocal", "Progressive", "Zero Power", "Reading Only"];
const LENS_MATERIALS = [
  "CR-39 (Plastic)", "Polycarbonate", "High-Index 1.60",
  "High-Index 1.67", "High-Index 1.74", "Trivex", "Glass",
];
const LENS_COATINGS = [
  "Anti-Glare (AR)", "Blue-Cut", "Photochromic",
  "Anti-Reflective", "Hydrophobic", "Scratch Resistant", "None",
];
const LENS_TINTS = ["Clear", "Gray", "Brown", "Green", "Blue", "Yellow", "Custom"];
const LENS_BRANDS = ["Essilor", "Zeiss", "Nikon", "Hoya", "Crizal", "Kodak", "Rodenstock", "Generic"];

function Row({ children }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {children}
    </div>
  );
}
function Sel({ label, name, value, onChange, options }) {
  return (
    <div>
      <label className="text-xs font-semibold text-slate-700">{label}</label>
      <select
        name={name}
        value={value || ""}
        onChange={onChange}
        className="mt-1 w-full h-11 rounded-md border border-slate-300 bg-white px-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
      >
        <option value="">Select…</option>
        {options.map((o) => (
          <option key={o}>{o}</option>
        ))}
      </select>
    </div>
  );
}
function Txt({ label, name, value, onChange, type = "text", placeholder }) {
  return (
    <div>
      <label className="text-xs font-semibold text-slate-700">{label}</label>
      <input
        type={type}
        name={name}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder || label}
        className="mt-1 w-full h-11 rounded-md border border-slate-300 px-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
      />
    </div>
  );
}

export default function NewLensesFields({ data, onChange }) {
  return (
    <div className="rounded-2xl border border-emerald-100 bg-emerald-50/30 p-5 space-y-4">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-emerald-600 to-teal-500 grid place-items-center shadow-sm">
          <Layers size={18} className="text-white" />
        </div>
        <div>
          <h3 className="text-base font-bold text-slate-900">New Lenses Order</h3>
          <p className="text-xs text-slate-500">Lens specifications for the customer&apos;s existing frame</p>
        </div>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3">
        <div className="flex items-center gap-2 text-xs font-semibold text-slate-700">
          <Sparkles size={13} className="text-emerald-600" /> Lens Specs
        </div>
        <Row>
          <Sel label="Lens Type" name="lens_type" value={data.lens_type} onChange={onChange} options={LENS_TYPES} />
          <Sel label="Material" name="lens_material" value={data.lens_material} onChange={onChange} options={LENS_MATERIALS} />
          <Sel label="Coating" name="lens_coating" value={data.lens_coating} onChange={onChange} options={LENS_COATINGS} />
          <Sel label="Tint" name="lens_tint" value={data.lens_tint} onChange={onChange} options={LENS_TINTS} />
          <Sel label="Brand" name="lens_brand" value={data.lens_brand} onChange={onChange} options={LENS_BRANDS} />
        </Row>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3">
        <div className="flex items-center gap-2 text-xs font-semibold text-slate-700">
          <Package2 size={13} className="text-emerald-600" /> Pricing & Delivery
        </div>
        <Row>
          <Txt label="Total Cost (₹)" name="lens_cost" value={data.lens_cost} onChange={onChange} type="number" placeholder="0" />
          <Txt label="Delivery Date" name="lens_delivery_date" value={data.lens_delivery_date} onChange={onChange} type="date" />
          <Txt label="Frame Condition" name="lens_frame_condition" value={data.lens_frame_condition} onChange={onChange} placeholder="Good / Loose / Bent" />
        </Row>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <label className="text-xs font-semibold text-slate-700 flex items-center gap-1.5">
          <Truck size={13} className="text-emerald-600" /> Notes / Special Instructions
        </label>
        <textarea
          rows={2}
          name="lens_notes"
          value={data.lens_notes || ""}
          onChange={onChange}
          placeholder="Cut size, edging, any custom request…"
          className="mt-1.5 w-full resize-none rounded-md border border-slate-300 p-2.5 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
        />
      </div>
    </div>
  );
}
